import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Stack,
} from '@mui/material';
import CelebrationIcon from '@mui/icons-material/Celebration';
import { useFeatureBadge } from '../../hooks/useFeatureBadge';

// 既読フラグキー: アップデートごとに新しい値にすれば未読扱いで再表示できる
const UPDATE_KEY = 'ui_update_2026_05_07';

interface UpdateSection {
  title: string;
  emoji: string;
  items: string[];
}

const sections: UpdateSection[] = [
  {
    emoji: '📱',
    title: '日報フォーム（モバイル）',
    items: [
      '工事情報を折りたたみ式に変更（現場名のみ常時表示）',
      '職長を前日の日報 or 工事担当者から自動入力',
      'メンバーをチップで一覧表示（自社=青系 / 外注=オレンジ系）',
      '工事完了チェックボックスを保存ボタンの上にも追加',
      '勤務・時間外を変更時に「他のメンバーにも適用しますか？」確認',
    ],
  },
  {
    emoji: '💻',
    title: '工事一覧',
    items: [
      'PC: 操作アイコンに項目名のヘッダー表示',
      'PC: デフォルト表示件数を 25 件に変更',
      'モバイル: スクロールで自動的に次の 5 件を読み込み（無限スクロール）',
    ],
  },
  {
    emoji: '🔍',
    title: '全画面共通',
    items: [
      'モバイルの左右余白を縮小',
      '横スワイプによる意図しないページ移動を抑止',
      'モバイルナビゲーションをハンバーガーメニュー化',
    ],
  },
];

export const WhatsNewDialog: React.FC = () => {
  const { isNew, markSeen } = useFeatureBadge(UPDATE_KEY);

  return (
    <Dialog
      open={isNew}
      onClose={markSeen}
      maxWidth="sm"
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CelebrationIcon color="primary" />
        UI をアップデートしました
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          以下の改善を反映しました。確認後、「OK」を押してください（次回以降は表示されません）。
        </Typography>
        <Stack spacing={2.5}>
          {sections.map((section) => (
            <Box key={section.title}>
              <Typography
                variant="subtitle2"
                color="primary"
                sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mb: 0.75 }}
              >
                <span>{section.emoji}</span>
                <span>{section.title}</span>
              </Typography>
              <Box component="ul" sx={{ pl: 2.5, m: 0 }}>
                {section.items.map((item) => (
                  <Typography
                    key={item}
                    component="li"
                    variant="body2"
                    sx={{ mb: 0.25 }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>
            </Box>
          ))}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={markSeen} variant="contained" fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
